export enum UserRoles {
  HrDepartmentHr = 'HrDepartmentHr',
  HrDepartmentAdmin = 'HrDepartmentAdmin',
}
